import React, { memo } from 'react'
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { AddCircle } from '@material-ui/icons';

const CustomButton = withStyles(theme => ({
    root: {
        boxShadow: '0 4px 8px 0 rgb(44 39 56 / 10%)',
        paddingTop: 10,
        border: 'none',
        borderRadius: 10,
        paddingBottom: 10,
        fontFamily: 'Poppins-Regular',
        textTransform: 'inherit',
        color: theme.palette.primary.main,
        fontWeight: 500,
        backgroundColor: '#cdd4e2',
        '$label': {
            fontSize: '1.15em',
        },
        '&:hover': {
            backgroundColor: '#979eac'
        }
    }
}))(Button);

const AddPilotButton = memo(({ onClick, children, className }) => {
    return <CustomButton startIcon={<AddCircle/>} className={className} onClick={onClick}>{children}</CustomButton>
});

export default AddPilotButton